import { RootState } from 'reduxStore/store';

export function selectAuth(state: RootState): RootState['firebase']['auth'] {
  return state.firebase.auth;
}
